<div class="my-5">
  <sm-page-header
    [breadcrumb]="breadcrumb"
    title="settings.dacScenarios.title">
  </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-data-table-builder [dataTableObject]="datatableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
  </div>
